import Phaser from 'phaser';
import { AudioManager } from '../systems/AudioManager';

export abstract class BaseScene extends Phaser.Scene {
  protected audioManager: AudioManager;

  constructor(config: Phaser.Types.Scenes.SettingsConfig) {
    super(config);
  }

  create(): void {
    // Initialize audio manager for all scenes
    this.audioManager = AudioManager.getInstance(this);
    
    // Add any common scene setup here
  }

  override update(time: number, delta: number): void {
    // Common update logic for all scenes
  }
  destroy(): void {
    this.audioManager.destroy();
  }
  protected addBackground(): void {
    // Create a starfield background
    const background = this.add.graphics();
    background.fillGradientStyle(0x0a0a2e, 0x0a0a2e, 0x16213e, 0x16213e);
    background.fillRect(0, 0, this.cameras.main.width, this.cameras.main.height);

    // Add some stars
    for (let i = 0; i < 100; i++) {
      const x = Math.random() * this.cameras.main.width;
      const y = Math.random() * this.cameras.main.height;
      const size = Math.random() * 2 + 0.5;
      const alpha = Math.random() * 0.8 + 0.2;
      
      const star = this.add.circle(x, y, size, 0xffffff, alpha);
      
      // Add twinkling effect
      this.tweens.add({
        targets: star,
        alpha: Math.random() * 0.5 + 0.2,
        duration: Math.random() * 2000 + 1000,
        yoyo: true,
        repeat: -1,
        ease: 'Sine.easeInOut'
      });
    }
  }

  protected showNotification(message: string, duration: number = 2000, color: string = '#4CAF50'): void {
    const centerX = this.cameras.main.centerX;
    const centerY = this.cameras.main.centerY;
    
    const notification = this.add.text(centerX, centerY - 100, message, {
      fontSize: '18px',
      color: color,
      backgroundColor: 'rgba(0,0,0,0.8)',
      padding: { x: 20, y: 15 },
      fontFamily: 'Arial',
      align: 'center',
    }).setOrigin(0.5);
    
    // Animate and remove
    this.tweens.add({
      targets: notification,
      alpha: 0,
      y: centerY - 150,
      duration: duration,
      onComplete: () => {
        notification.destroy();
      }
    });
  }
} 